<div class="register">
  <div class="body">
    <div class="company-container flex flex-col gap-16">
      <div class="inp">
        <fun-input placeholder="{{'register.company.company_street' | translate}}"
          [parentForm]="partnerForm"
          [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages"
          [isSubmit]="isSubmit"
          controlName="residenceAddress"
          type="text"
          [errorLogin]="errorAmount"
          labelName="{{'register.company.company_address' | translate}}"
          (keyup)="getInfo()"
          (click)="getInfo()"></fun-input>
      </div>
      <div class="inp">
        <fun-input placeholder="Ciudad de residencia"
          [parentForm]="partnerForm"
          [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages"
          [isSubmit]="isSubmit"
          controlName="residenceCity"
          type="text"
          [errorLogin]="errorAmount"
          labelName="Ciudad de residencia"
          (keyup)="getInfo()"
          (click)="getInfo()"></fun-input>
      </div>
      <div class="inp">
        <fun-input placeholder="Provincia"
          [parentForm]="partnerForm"
          [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages"
          [isSubmit]="isSubmit"
          controlName="residenceRegion"
          type="text"
          [errorLogin]="errorAmount"
          labelName="Provincia"
          (keyup)="getInfo()"
          (click)="getInfo()"></fun-input>
      </div>
      <div class="inp">
        <fun-input placeholder="Código postal"
          [parentForm]="partnerForm"
          [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages"
          [isSubmit]="isSubmit"
          controlName="residencePostalCode"
          type="text"
          [errorLogin]="errorAmount"
          labelName="Código Postal"
          (keyup)="getInfo()"
          (click)="getInfo()"></fun-input>
      </div>
      <div class="inp">
        <fun-input *ngIf="countriesLoaded"
          placeholder="País de residencia"
          [parentForm]="partnerForm"
          [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages"
          [isSubmit]="isSubmit"
          controlName="residenceCountry"
          type="select"
          [errorLogin]="errorAmount"
          labelName="País de residencia"
          (selectChange)="getInfo()"
          (keyup)="getInfo()"
          (click)="getInfo()"
          [items]="countriesList"
          [selectedItem]="108"></fun-input>
        <fun-skeleton-input *ngIf="!countriesLoaded"></fun-skeleton-input>
      </div>
    </div>
  </div>
</div>